import React from "react";
import { scoreColor } from "../lib/api";

export const ScoreCircle = ({ score = 0, size = 180, stroke = 12, label = true }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  const color = scoreColor(score);
  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-circle">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#1B2B5E" strokeOpacity="0.08" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-playfair leading-none" style={{ color, fontSize: size * 0.3 }}>
          {score}
        </span>
        {label && <span className="text-[0.62rem] uppercase tracking-[0.2em] text-navy/50 mt-1">Provenance</span>}
      </div>
    </div>
  );
};
